import { INode } from "../../@types/device";
import { ServiceContextType } from "../../@types/service";
import { gaugeCfg, pct, rawValue } from "../../lib/node";
import PanSlider from "../PanSlider";

export default function Gauge({
  node,
  ctx,
}: {
  node: INode;
  ctx: ServiceContextType;
}) {
  const { min, max, unit } = gaugeCfg(node);
  const raw = rawValue(ctx, node.addr, node.stateKey);
  const filled = pct(raw, min, max);

  return (
    <div className="flex flex-col items-center mt-4">
      <PanSlider value={filled} />
      <div className="mt-2 text-sm opacity-60">
        {raw === undefined ? "--" : `${Math.round(filled)}%`}
        {unit && raw !== undefined && ` (${raw}${unit})`}
      </div>
    </div>
  );
}
